// extracted by mini-css-extract-plugin
module.exports = {"tabsBlock":"TabPanel_tabsBlock__3nN3B","tabItem":"TabPanel_tabItem__3bO4i","active":"TabPanel_active__2hiSU"};